module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/customer/customer-03-ba1a47e3c2ced703926dd99edda5e285.jpg";